<template>
  <div class="Quota">
    <div class="TopSearch">
      <FromComm :FromArr="FromArr"></FromComm>
      <div class="btngroup">
        <CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
      </div>
    </div>
    <div class="BottomTable">
      <div style="display: inline-block;">
        <!-- v-if="qx.add" -->
        <Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add" :src="require('@/assets/icon/icon-add.png')">
        </Commonbtn>
      </div>
      <div style="display: inline-block;">
        <!--  v-if="qx.update" -->
        <Commonbtn backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
        </Commonbtn>
      </div>
      <!-- <div style="margin-left: 10px;display: inline-block;">
        <Commonbtn backgroundColor="#F9FAFC" title="删除" fontSize="14px" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
        </Commonbtn>
      </div> -->
      <div class="Table">
        <Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" width="1000px" colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
        </Commontable>
        <div class="pagination">
          <Pagination ref="invPagination" type='allColor' :PageSize="pageSize" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
        </div>
      </div>
    </div>
    <DialogFrom width="1060px" :title="TitleEditor" :OKASCAN="true" :dialogVisible="dialogVisibleEditor" @cancel="cancelEditor" @dialogOK="dialogOKEditor">
      <FromComm :FromArr="FromArrEditor"></FromComm>
    </DialogFrom>
    <DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg" @dialogOK="dialogOKdrjg">
      <div class="from">
        <Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
        </Commontable>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条信息吗？</span>
    </Dialog>

  </div>
</template>

<script>
import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '../../../../../../components/commongroup.vue'
import Commonbtn from '../../../../../../components/common-btn.vue'
import Commontable from '../../../../../../components/common-table.vue'
import Pagination from '../../../../../../components/pagination.vue'
import DialogFrom from '../../../../../../components/dialog-from.vue'
import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
import Dialog from '../../../../../../components/dialog.vue'
import utils from '../../../../../../common/utils'
import headerData from './headerData/headerData'
import FromArr from './FormData/FromArr'
import FromArrEditor from './FormData/FromArrEditor'
import {
  InventoryClassList
} from '@/api/home'
import {
  QuotaDefaultRatioList,
  QuotaDefaultRatioInfo,
  QuotaDefaultRatioAdd,
  QuotaDefaultRatioEdit
} from '@/api/channel'
import { json } from 'body-parser'
export default {
  components: { FromComm, CommonBtngroup, Commonbtn, Commontable, Pagination, DialogFrom, CommonbtnUpLoad, Dialog },
  props: {},
  data() {
    return {
      dialogVisibleEditor: false,
      dialogVisiblesdrjg: false,
      dialogVisibleDel: false,
      PageIndex: 1,
      pageSize: 10,
      total: 0,
      FromArr: [],
      FromArrEditor: [],
      headerData: [],
      tableData: [],
      tableDatadrjg: [],
      Quotaarr: [],
      title: "",
      TitleEditor: "",
      invClassInfo: "",
      StyleCss: {
        position: 'relative',
        left: -930,
        right: -62,
        opacityGCTQ: 1,
        opacityGQYL: 0
      },
      from: {
        InvClass: '',
      }
    }
  },
  created() {
    this.QuotaDefaultRatioList()
    this.inventoryClassList()
  },
  mounted() {
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async QuotaDefaultRatioList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await QuotaDefaultRatioList({
        invClass: this.from.InvClass,
        pageSize: this.pageSize,
        pageIndex: this.PageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tableData = data.data

      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
      loading.close();
    },
    // 新增
    async QuotaDefaultRatioAdd() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let AddCount = 0
      this.FromArrEditor.forEach((item, index) => {
        if (index != 0) {
          AddCount += ~~item.modelValue
        }
      })
      console.log(AddCount, 'AddCount');
      if (AddCount > 100) {
        this.$message.warning('十二个月默认分摊比例合计必须是100%')
        AddCount = 0
        loading.close();
        return
      }
      let {
        code,
        message,
        data
      } = await QuotaDefaultRatioAdd({
        invClass: this.FromArrEditor[0].modelvalue,
        janRatio: this.FromArrEditor[1].modelValue,
        febRatio: this.FromArrEditor[2].modelValue,
        marRatio: this.FromArrEditor[3].modelValue,
        aprRatio: this.FromArrEditor[4].modelValue,
        mayRatio: this.FromArrEditor[5].modelValue,
        junRatio: this.FromArrEditor[6].modelValue,
        julRatio: this.FromArrEditor[7].modelValue,
        augRatio: this.FromArrEditor[8].modelValue,
        sepRatio: this.FromArrEditor[9].modelValue,
        octRatio: this.FromArrEditor[10].modelValue,
        novRatio: this.FromArrEditor[11].modelValue,
        decRatio: this.FromArrEditor[12].modelValue
      })
      if (code == 0) {
        this.QuotaDefaultRatioList()
        this.$message.success(message)
        this.dialogVisibleEditor = false
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 查看
    async QuotaDefaultRatioInfo() {
      if (this.invClassInfo == '') {
        this.$message.warning('选择需要操作的数据！')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await QuotaDefaultRatioInfo({
        invClass: this.invClassInfo
      })
      if (code == 0) {
        this.FromArrEditor[0].modelvalue = data.InvClass
        this.FromArrEditor[1].modelValue = data.data.JanRatio
        this.FromArrEditor[2].modelValue = data.data.FebRatio
        this.FromArrEditor[3].modelValue = data.data.MarRatio
        this.FromArrEditor[4].modelValue = data.data.AprRatio
        this.FromArrEditor[5].modelValue = data.data.MayRatio
        this.FromArrEditor[6].modelValue = data.data.JunRatio
        this.FromArrEditor[7].modelValue = data.data.JulRatio
        this.FromArrEditor[8].modelValue = data.data.AugRatio
        this.FromArrEditor[9].modelValue = data.data.SepRatio
        this.FromArrEditor[10].modelValue = data.data.OctRatio
        this.FromArrEditor[11].modelValue = data.data.NovRatio
        this.FromArrEditor[12].modelValue = data.data.DecRatio
        this.dialogVisibleEditor = true
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 修改
    async QuotaDefaultRatioEdit() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let AddCount = 0
      this.FromArrEditor.forEach((item, index) => {
        if (index != 0) {
          AddCount += ~~item.modelValue
        }
      })
      console.log(AddCount, 'AddCount修改');
      if (AddCount > 100) {
        this.$message.warning('十二个月默认分摊比例合计必须是100%')
        AddCount = 0
        loading.close();
        return false
      }
      let {
        code,
        message,
        data
      } = await QuotaDefaultRatioEdit({
        invClass: this.FromArrEditor[0].modelvalue,
        janRatio: this.FromArrEditor[1].modelValue,
        febRatio: this.FromArrEditor[2].modelValue,
        marRatio: this.FromArrEditor[3].modelValue,
        aprRatio: this.FromArrEditor[4].modelValue,
        mayRatio: this.FromArrEditor[5].modelValue,
        junRatio: this.FromArrEditor[6].modelValue,
        julRatio: this.FromArrEditor[7].modelValue,
        augRatio: this.FromArrEditor[8].modelValue,
        sepRatio: this.FromArrEditor[9].modelValue,
        octRatio: this.FromArrEditor[10].modelValue,
        novRatio: this.FromArrEditor[11].modelValue,
        decRatio: this.FromArrEditor[12].modelValue
      })
      if (code == 0) {
         this.QuotaDefaultRatioList()
        this.$message.success(message)
        this.dialogVisibleEditor = false
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 产品线下拉
    async inventoryClassList() {
      let {
        code,
        data
      } = await InventoryClassList({
      })
      if (code == 0) {
        this.FromArr[0].options = []
        this.FromArrEditor[0].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.InvClass,
            value: item.InvClassName
          }
          this.FromArr[0].options.push(obj)
          this.FromArrEditor[0].options.push(obj)
        })
      } else {
        this.$message.error('加载失败')
      }
    },
    add() {
      this.TitleEditor = '新增指标默认分摊比例'
      this.dialogVisibleEditor = true

    },
    update() {
      this.TitleEditor = '修改指标默认分摊比例'
      this.QuotaDefaultRatioInfo()

    },
    showclick() {

    },
    hide() {

    },
    select() {
      this.from.InvClass = this.FromArr[0].modelvalue
      this.QuotaDefaultRatioList()
    },
    reset() {
      this.FromArr.map((item, index) => {
        item.modelvalue = '';
      })
    },
    handleSelectionChange(val) {
      console.log(val, 'val');
      this.QuotaArrSelect = val;
    },
    onRowClick(val) {
      this.invClassInfo = val.InvClass
      console.log(val, 'val');
    },
    handleCurrentChange(PageIndex) {
      this.PageIndex = PageIndex
      this.QuotaDefaultRatioList()
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize
      this.QuotaDefaultRatioList()
    },
    cancelEditor() {
      this.dialogVisibleEditor = false
    },
    dialogOKEditor() {
      if (this.TitleEditor == '新增指标默认分摊比例') {
        this.QuotaDefaultRatioAdd()
      }
      if (this.TitleEditor == '修改指标默认分摊比例') {
        this.QuotaDefaultRatioEdit()
      }
    },
    canceldrjg() {
      this.dialogVisiblesdrjg = false
    },
    dialogOKdrjg() {
      this.dialogVisiblesdrjg = false
    },
    cancelDel() {
      this.dialogVisibleDel = false
    },
    dialogOKDel() {
      let ID = []
      this.QuotaArrSelect.forEach((item, index) => {
        ID.push(item.ID)
      })
      this.CustomerQuotaDelete(ID)
      this.dialogVisibleDel = false
    },
  },
  computed: {},
  watch: {
    dialogVisibleEditor: {
      handler(NewVal, OldVal) {
        if (!NewVal) {
          this.FromArrEditor.forEach((item, index) => {
            if (index == 0) {
              item.modelvalue = ''
            }
            item.modelValue = undefined
          })
        }
      }
    }
  },
}
</script>
<style scoped lang='less'>
.GCTQ {
  // border: 1px solid red;
  transition: all 0.5s;
}
.GCYL {
  //  border: 1px solid rgb(23, 120, 211);
  transition: all 0.5s;
}
.Quota {
  width: 100%;
  height: 100%;
  position: relative;
  .TopSearch {
    /* margin: 1px 10px;
    width: 938px; */
	margin-top:24px;
    height: 70px;
    // border: 1px solid #e5e7ea;
    // padding-bottom: 10px;
    box-shadow: 0px 1px 4px 2px #e5e7ea;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .btngroup {
      // border: 1px solid #0b65ec;
      position: relative;
      bottom: 20px;
    }
  }
  .BottomTable {
   /* margin: 32px 10px; */
    padding: 10px;
    /* width: 920px; */
	margin-top:24px;
    // height: 518px;
    // border: 1px solid #e5e7ea;
    box-shadow: 0px 1px 4px 2px #e5e7ea;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
</style>